import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { importsByIdReducers, importsByIdWatchers } from './_id';
import { importsLatestReducers, importsLatestWatchers } from './latest';
import { importsSalesforceReducers, importsSalesforceWatchers } from './salesforce';

export const importsReducers = combineReducers({
	byId: importsByIdReducers,
	latest: importsLatestReducers,
	salesforce: importsSalesforceReducers
});

export const importsWatchers = combineAllWatchers([
	importsByIdWatchers,
	importsLatestWatchers,
	importsSalesforceWatchers
]);
